document.addEventListener("DOMContentLoaded", () => {
    const key = "wishlist",
        wishlistBlock = document.querySelector(".js-wishlistBlock"),
        wishlistButtons = document.querySelectorAll(".wishlist_button");
    document.body.classList.contains("wishlist") && wishlistBlock && (wishlistBlock.innerHTML = `
      <div class="wishlist-skeleton" style="width:100%;min-height:400px;display:flex;align-items:center;justify-content:center;">
        <img src="https://cdn.shopify.com/s/files/1/0857/2085/8938/files/Kymee-Logo.gif?v=1760423991" width="100px" height="auto" alt="Loading..." loading="lazy" decoding="async">
      </div>`);

    function syncWishlistButtons() {
        const list = JSON.parse(localStorage.getItem(key)) || [];
        document.querySelectorAll(".wishlist_button").forEach(btn => {
            btn.classList.toggle("active", list.some(i => i.productVariant === btn.dataset.productVariantId))
        })
    }
    syncWishlistButtons(), updateWishlistCount(), document.body.classList.contains("wishlist") && requestAnimationFrame(displayWishlist), document.addEventListener("click", async e => {
        const btn = e.target.closest(".wishlist_button"),
            removeBtn = e.target.closest(".remove_wishlist"),
            moveBtn = e.target.closest(".move_to_cart");
        if (!(btn && btn.dataset.fromModal === "true")) {
            if (removeBtn) {
                e.preventDefault(), e.stopPropagation();
                const title = removeBtn.dataset.productTitle,
                    variantId = removeBtn.dataset.productVariantId;
                let list = JSON.parse(localStorage.getItem(key)) || [];
                list = list.filter(i => i.productTitle !== title), localStorage.setItem(key, JSON.stringify(list)), syncWishlistButtons(), updateWishlistCount(), document.body.classList.contains("wishlist") && requestAnimationFrame(displayWishlist);
                return
            }
            if (moveBtn) {
                e.preventDefault(), e.stopPropagation();
                const variantId = moveBtn.dataset.productVariantId,
                    title = moveBtn.dataset.productTitle;
                moveBtn.textContent = "Moving...", moveBtn.style.opacity = "0.6", moveBtn.setAttribute("aria-disabled", "true");
                try {
                    if (!(await fetch("/cart/add.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                id: variantId,
                                quantity: 1
                            })
                        })).ok) throw new Error("Add to cart failed");
                    let list = JSON.parse(localStorage.getItem(key)) || [];
                    list = list.filter(i => i.productVariant !== variantId), localStorage.setItem(key, JSON.stringify(list)), syncWishlistButtons(), updateWishlistCount(), document.body.classList.contains("wishlist") && requestAnimationFrame(displayWishlist), typeof updateCartCount == "function" && updateCartCount(), typeof fetchCartDrawer == "function" && fetchCartDrawer(), setTimeout(() => {
                        const drawer = document.querySelector(".cart-drawer__dialog");
                        drawer && (drawer.open = !0), document.documentElement.setAttribute("scroll-lock", "")
                    }, 500)
                } catch (err) {
                    console.error("Move to cart error:", err), alert("Unable to add product to cart.")
                } finally {
                    moveBtn.textContent = "Move to Cart", moveBtn.style.opacity = "1", moveBtn.removeAttribute("aria-disabled")
                }
            }
            if (btn) {
                const data = {
                    productTitle: btn.dataset.productTitle,
                    productImg: btn.dataset.productImg,
                    productPrice: btn.dataset.productPrice,
                    productUrl: btn.dataset.productUrl,
                    productId: btn.dataset.productId,
                    productVariant: btn.dataset.productVariantId
                };
                let list = JSON.parse(localStorage.getItem(key)) || [];
                const index = list.findIndex(i => i.productVariant === data.productVariant);
                index === -1 ? list.push(data) : list.splice(index, 1), localStorage.setItem(key, JSON.stringify(list)), syncWishlistButtons(), updateWishlistCount();
                return
            }
        }
    });

    function displayWishlist() {
        const list = JSON.parse(localStorage.getItem(key)) || [];
        if (!wishlistBlock) return;
        if (!list.length) {
            wishlistBlock.innerHTML = `
        <div class="wishlist-empty" style="min-height:400px;display:flex;align-items:center;justify-content:center;">
          <img src="https://cdn.shopify.com/s/files/1/0857/2085/8938/files/Animation_-_1741693242592.gif?v=1741693298" width="200" height="200" alt="Empty" loading="lazy">
        </div>`;
            return
        } 
        const query = list.map(i => "id:" + i.productId).join(" OR ");
        console.log("aaaaaaa" + query);
        fetch(`/search?section_id=wishlist-render&type=product&q=${encodeURIComponent(query)}`).then(res => res.text()).then(html => {
            const temp = document.createElement("div");
            temp.innerHTML = html;
            const section = temp.querySelector("[data-wishlist-render]");
            section && section.innerHTML.trim() ? wishlistBlock.innerHTML = section.innerHTML : wishlistBlock.innerHTML = "<p>No wishlist items found.</p>"
        }).catch(err => {
            console.error("Wishlist render error:", err), wishlistBlock.innerHTML = "<p>Error loading wishlist.</p>"
        })


    }

    function updateWishlistCount() {
        const count = (JSON.parse(localStorage.getItem("wishlist")) || []).length;
        document.querySelectorAll(".wishlist-total-count").forEach(el => {
            el.textContent = count, el.dataset.total = count
        })
    }

    function fetchCartDrawer() {
        const drawer = document.querySelector(".cart-drawer__dialog");
        drawer && fetch("/cart?sections=cart-drawer").then(r => r.json()).then(data => {
            const html = data["cart-drawer"],
                temp = document.createElement("div");
            temp.innerHTML = html;
            const newInner = temp.querySelector(".cart-drawer__content"),
                oldInner = drawer.querySelector(".cart-drawer__content");
            newInner && oldInner && (oldInner.innerHTML = newInner.innerHTML)
        }).catch(e => console.error("Drawer update failed:", e))
    }

    function updateCartCount() {
        $.ajax({
            type: "GET",
            url: "/cart.js",
            dataType: "json",
            success: cart => $(".cart-bubble__text-count").text(cart.item_count)
        })
    } 
    document.addEventListener("wishlist:updated", () => {
        updateWishlistCount(), syncWishlistButtons(), document.body.classList.contains("wishlist") && requestAnimationFrame(displayWishlist)
    })
});
//# sourceMappingURL=/cdn/shop/t/112/assets/wishlist.js.map?v=93221550258614702861768548319